import { useMediaQuery } from 'react-responsive'

export const API_BASE_URL = 'https://images.dentalstores.in/api/v2';
export const OLD_API_BASE_URL = 'https://images.dentalstores.in/api'; // New constant for old API
export const BASE_URL = 'https://images.dentalstores.in';
export const CSRF = 'https://images.dentalstores.in/sanctum/csrf-cookie';
export const API_KEY_ID= 'dsin_live_UCaGUiqyAde5VK'
export const API_KEY_SECRET= '9bdff78d-6efe-4311-ba2b-60f380942cd5'

export const ANDROID = 'https://play.google.com/store/apps/details?id=com.dentalstoresin&hl=en'

export const IMG = {
    logo: require('../assets/imgs/logo.svg').default,
    tag: require('../assets/imgs/tag.svg').default,
    examination: require('../assets/imgs/examination.svg').default,
    ellipseWhite: require('../assets/imgs/ellipseWhite.svg').default,
    authblur: require('../assets/imgs/authblur.png'),
    cempty: require('../assets/imgs/cempty.png'),
    mobile: require('../assets/imgs/app.webp'),
}

export const Icons = {
    eyeFrame: require('../assets/imgs/icons/eye-frame.svg').default,
    eyeSlash: require('../assets/imgs/icons/eye-slash.svg').default,
    remove: require('../assets/imgs/icons/remove.svg').default,
    icDelete: require('../assets/imgs/icons/icDelete.svg').default,
    radioButtonDisabled: require('../assets/imgs/icons/radio_button_disabled.svg').default,
    radioButtonEnabled: require('../assets/imgs/icons/radio_button_enabled.svg').default,
    savingsCoin: require('../assets/imgs/icons/savings-coin.png'),
    shipping: require('../assets/imgs/icons/shipping.png'),
    support: require('../assets/imgs/icons/support.png'),
    secure: require('../assets/imgs/icons/secure.png'),
    cod: require('../assets/imgs/icons/cod.png'),
}

export const useDeviceType = () => {
    const isDesktop = useMediaQuery({ minWidth: 1025 });
    const isTablet = useMediaQuery({ maxWidth: 1024 });
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return { isDesktop, isTablet, isMobile };
};
